<template>
  <v-form ref="api-key-form" :class="['api-key-form']" lazy-validation @submit.prevent="getApiKey" v-model="apiKeyFormValid">
    <v-card>
      <v-card-text>
          <p v-html="$lang.apiKeyInstructions" />
          <v-text-field prepend-icon="mdi-email" :rules="email" :label="$lang.email" :color="$config.colors.primary" v-model="emailInput" required />
          <v-alert outline :value="apiKeyGeneratedResponse" type="success" :color="$config.colors.primary">
            <div v-html="apiKeyGeneratedResponse" />
          </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn type="submit" block small :loading="formSubmitting" aria-label="get-api-key" :color="$config.colors.primary" :title="$lang.getApiKey">{{ $lang.getApiKey }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import email from '../helpers/rules-email'

export default {
  name: 'ApiKeyForm',
  data () {
    return {
      email,
      emailInput: '',
      apiKeyGeneratedResponse: '',
      apiKeyFormValid: false,
      formSubmitting: false
    }
  },
  methods: {
    getApiKey () {
      if (this.$refs['api-key-form'].validate()) {
        const url = `${this.$config.apiRoot}/apikey`
        this.formSubmitting = true
        this.$http({
          url,
          data: {
            email: this.emailInput
          },
          method: 'POST'
        }).then(response => {
          this.apiKeyGeneratedResponse = this.$lang.apiKeyGeneratedResponse(response.data.data.key)
          this.formSubmitting = false
        }).catch(error => {
          console.error(error)
          this.formSubmitting = false
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/api-key-form.vue